import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./performanceApiClient";

export const listGoalCycles = async (params = {}) =>
  getRequest("/masters/goal-cycles", { params });

export const createGoalCycle = async (payload) =>
  postRequest("/masters/goal-cycles", payload);

export const archiveGoalCycle = async (goalCycleId) =>
  deleteRequest(`/masters/goal-cycles/${goalCycleId}`);

export const updateGoalCycleStatus = async (goalCycleId, payload) =>
  putRequest(`/masters/goal-cycles/${goalCycleId}/status`, payload);

export const listFeedbackTypes = async (params = {}) =>
  getRequest("/masters/feedback-types", { params });

export const createFeedbackType = async (payload) =>
  postRequest("/masters/feedback-types", payload);

export const listReviewTemplates = async (params = {}) =>
  getRequest("/masters/review-templates", { params });

export const createReviewTemplate = async (payload) =>
  postRequest("/masters/review-templates", payload);

export default {
  listGoalCycles,
  createGoalCycle,
  archiveGoalCycle,
  updateGoalCycleStatus,
  listFeedbackTypes,
  createFeedbackType,
  listReviewTemplates,
  createReviewTemplate,
};
